import { Reveal } from "./Motion";
import { LineIcon } from "./LineIcon";

export const IconCard = ({ id, icon, title, text, n, i = 0, prefix = "service-card" }) => (
  <Reveal delay={(i % 3) * 0.08} className="h-full">
    <article
      data-testid={`${prefix}-${id}`}
      className="group relative flex h-full flex-col rounded-2xl border border-[#E5E1D3] bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1 hover:border-[#74DC26] hover:shadow-[0_24px_60px_-30px_rgba(8,38,25,0.35)]"
    >
      <div className="flex items-start justify-between">
        <span className="grid h-14 w-14 place-items-center rounded-full border border-[#082619]/15 text-[#082619] transition-colors duration-500 group-hover:bg-[#082619] group-hover:text-[#74DC26]">
          <LineIcon name={icon} />
        </span>
        {n && <span className="font-mono text-xs text-[#4C6053]">{n}</span>}
      </div>
      <h3 className="font-display mt-10 text-xl md:text-2xl font-medium leading-snug text-[#082619]">{title}</h3>
      <p className="mt-3 text-sm leading-relaxed text-[#4C6053]">{text}</p>
    </article>
  </Reveal>
);
